module.exports = __webpack_public_path__ + "static/media/step-3.0c0ad7f9.png";